 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-06a15036":"dffaddf9","chunk-08b5b1ae":"5ad8f6b1","chunk-09d6dff3":"44b809de","chunk-0c2ba875":"12aa6b2f","chunk-109e4a0e":"054777e6","chunk-125d9736":"050177ef","chunk-13118c86":"ff69fa72","chunk-1881c65f":"f9fac964","chunk-1a324f0c":"418186e2","chunk-1b247cbd":"081262d9","chunk-1bc8f52c":"ec4cb008","chunk-1dbe5eaf":"30a99a07","chunk-20452b85":"f792484c","chunk-208c2446":"ae97d0c5","chunk-2349b137":"909d11cd","chunk-28466fc8":"15e8052f","chunk-2be04912":"501fb047","chunk-2d0b345c":"c3e81ec2","chunk-2d0bce05":"b115a7b7","chunk-2d0c77ad":"1e3a26d0","chunk-2d0c8f6d":"c08c4c12","chunk-2d0c91d2":"cdb69ac1","chunk-2d0cb6e8":"9d187e00","chunk-2d0cbb33":"d0630bb4","chunk-2d0d0818":"fb874c73","chunk-2d0da2ea":"68edc309","chunk-2d0da6a8":"219a853c","chunk-2d0dace4":"06b0ac85","chunk-2d0e95df":"79de6acf","chunk-2d210c28":"a893759f","chunk-2d212fd8":"732bb602","chunk-2d217361":"a7999a6c","chunk-2d2253ae":"796ee9bf","chunk-303254b2":"a0a973db","chunk-347ebcac":"79b8e9cf","chunk-354b2aa8":"43473a25","chunk-35a579a2":"0281f2ab","chunk-38867a61":"438f207e","chunk-3b7d8115":"cbee0e86","chunk-3d675996":"f6f96a65","chunk-3dbd8674":"045f3996","chunk-3e7f77bf":"68b70c69","chunk-41ce4c8b":"8daadfe9","chunk-41ef6366":"cead6ff7","chunk-44a3da96":"9a17231e","chunk-44eaecce":"38db1bc1","chunk-49117393":"030a542d","chunk-4b380372":"77ee3054","chunk-4d17f324":"bb95a60a","chunk-4e2b9ee0":"b578998e","chunk-4eb6a338":"2cb18ebc","chunk-500f1185":"4042ecfe","chunk-51bf7232":"196f39f4","chunk-52c84d8c":"47156911","chunk-545326c0":"3e349679","chunk-56cc7a73":"d177fc4e","chunk-56dec1a4":"552667bf","chunk-5a84305a":"c9dfde27","chunk-5af9d9b0":"e9941de5","chunk-5ddea5ea":"3b19670b","chunk-5fd9ef88":"fe3bd95e","chunk-609a6aeb":"fe647b49","chunk-609e28f6":"fab517c4","chunk-636f4260":"c054666c","chunk-646bac48":"6d5e6a22","chunk-66173c80":"979bfd24","chunk-6700755d":"a9693f95","chunk-67147130":"e06078b3","chunk-67811b1b":"37f8174b","chunk-67db813b":"6c0b047e","chunk-6993bb39":"5740a442","chunk-6ac44d3d":"3011d07a","chunk-6b3b5ac7":"8992895a","chunk-6cd8d239":"5c3d6449","chunk-4dc0318a":"339975c8","chunk-c154174a":"78f128cd","chunk-6d7092e8":"77f5483f","chunk-6d90af06":"45012b86","chunk-6e6dcf96":"4b8e164a","chunk-6f384fdc":"ecc302ca","chunk-6f5955ca":"803fc39c","chunk-00357acc":"02a13876","chunk-17d2ea76":"09a70819","chunk-31e3aaf3":"faaa2276","chunk-3635a07f":"08ac40bb","chunk-4b330e93":"2260935a","chunk-4e2546e6":"d13e2439","chunk-540eb546":"80530d4f","chunk-59d91b22":"37b1ec4e","chunk-844aa964":"0764cf64","chunk-8f099ab8":"45f86e7d","chunk-9fe4383e":"0a88427f","chunk-b92141c0":"f335dba7","chunk-dd2b1d46":"e85bf5c2","chunk-6f60227b":"f2e1d9b8","chunk-70e35ebc":"25d9bef8","chunk-711ff2f0":"e23870a2","chunk-71bd526a":"715aabb2","chunk-72294d4c":"4f60cbff","chunk-73e9d5f2":"73d5953b","chunk-744c292d":"551d3bad","chunk-7459c046":"15b887e4","chunk-75203fab":"b1ac3d47","chunk-75b8b6cb":"dfd6fcd5","chunk-77f6f964":"e9232538","chunk-78ab511f":"a7393467","chunk-7cdb600e":"0694d92b","chunk-7e16cd9d":"33c44ff1","chunk-7ed8b0ce":"87465810","chunk-7f66c91b":"cad3ff2b","chunk-7f706172":"68078d30","chunk-7fb62e64":"ee41c11d","chunk-8039543e":"04730885","chunk-8c0aeddc":"185bc046","chunk-2b02de32":"00a727c4","chunk-7f881edd":"895d7018","chunk-9827d096":"c82d1770","chunk-982b6af2":"6a2e47e5","chunk-99bcc778":"ec701387","chunk-9ac5abb0":"078f3091","chunk-9eba3760":"c81e17a8","chunk-a39ff88a":"5693d181","chunk-a8544154":"bed092e6","chunk-ac7c3ac8":"3bb2b8bc","chunk-adc2bb66":"da338bd9","chunk-b0a53dac":"b96fcd77","chunk-b81bcb8a":"899a5eca","chunk-ba7d386c":"2e458072","chunk-bb9055bc":"f7e657d2","chunk-bc926f2a":"87c92476","chunk-c5f01380":"76965955","chunk-c6b29aa4":"c1801610","chunk-cf78b932":"11e55e3d","chunk-d2175d8a":"6e507f72","chunk-e1a6d904":"c681a3b8","chunk-ed77b080":"18e3a0a5","chunk-faf9c3f6":"e117f80c","fail":"c272dbef","lang-en-US":"ac8f3aa2","lang-en-US-setting":"fcce41ed","lang-vi":"23307221","lang-vi-setting":"8f8c24a9","user":"54d7c1a0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08b5b1ae":1,"chunk-1dbe5eaf":1,"chunk-354b2aa8":1,"chunk-56cc7a73":1,"chunk-56dec1a4":1,"chunk-609a6aeb":1,"chunk-609e28f6":1,"chunk-636f4260":1,"chunk-6700755d":1,"chunk-6cd8d239":1,"chunk-4dc0318a":1,"chunk-c154174a":1,"chunk-744c292d":1,"chunk-7459c046":1,"chunk-7ed8b0ce":1,"chunk-7f66c91b":1,"chunk-7f706172":1,"chunk-8039543e":1,"chunk-a39ff88a":1,"chunk-d2175d8a":1,"chunk-faf9c3f6":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"fail":"fail","lang-en-US":"lang-en-US","lang-en-US-setting":"lang-en-US-setting","lang-vi":"lang-vi","lang-vi-setting":"lang-vi-setting","user":"user"}[chunkId]||chunkId) + "." + {"chunk-06a15036":"31d6cfe0","chunk-08b5b1ae":"4f477acb","chunk-09d6dff3":"31d6cfe0","chunk-0c2ba875":"31d6cfe0","chunk-109e4a0e":"31d6cfe0","chunk-125d9736":"31d6cfe0","chunk-13118c86":"31d6cfe0","chunk-1881c65f":"31d6cfe0","chunk-1a324f0c":"31d6cfe0","chunk-1b247cbd":"31d6cfe0","chunk-1bc8f52c":"31d6cfe0","chunk-1dbe5eaf":"41bd5bb8","chunk-20452b85":"31d6cfe0","chunk-208c2446":"31d6cfe0","chunk-2349b137":"31d6cfe0","chunk-28466fc8":"31d6cfe0","chunk-2be04912":"31d6cfe0","chunk-2d0b345c":"31d6cfe0","chunk-2d0bce05":"31d6cfe0","chunk-2d0c77ad":"31d6cfe0","chunk-2d0c8f6d":"31d6cfe0","chunk-2d0c91d2":"31d6cfe0","chunk-2d0cb6e8":"31d6cfe0","chunk-2d0cbb33":"31d6cfe0","chunk-2d0d0818":"31d6cfe0","chunk-2d0da2ea":"31d6cfe0","chunk-2d0da6a8":"31d6cfe0","chunk-2d0dace4":"31d6cfe0","chunk-2d0e95df":"31d6cfe0","chunk-2d210c28":"31d6cfe0","chunk-2d212fd8":"31d6cfe0","chunk-2d217361":"31d6cfe0","chunk-2d2253ae":"31d6cfe0","chunk-303254b2":"31d6cfe0","chunk-347ebcac":"31d6cfe0","chunk-354b2aa8":"1b938cc5","chunk-35a579a2":"31d6cfe0","chunk-38867a61":"31d6cfe0","chunk-3b7d8115":"31d6cfe0","chunk-3d675996":"31d6cfe0","chunk-3dbd8674":"31d6cfe0","chunk-3e7f77bf":"31d6cfe0","chunk-41ce4c8b":"31d6cfe0","chunk-41ef6366":"31d6cfe0","chunk-44a3da96":"31d6cfe0","chunk-44eaecce":"31d6cfe0","chunk-49117393":"31d6cfe0","chunk-4b380372":"31d6cfe0","chunk-4d17f324":"31d6cfe0","chunk-4e2b9ee0":"31d6cfe0","chunk-4eb6a338":"31d6cfe0","chunk-500f1185":"31d6cfe0","chunk-51bf7232":"31d6cfe0","chunk-52c84d8c":"31d6cfe0","chunk-545326c0":"31d6cfe0","chunk-56cc7a73":"817f0b53","chunk-56dec1a4":"8a41c503","chunk-5a84305a":"31d6cfe0","chunk-5af9d9b0":"31d6cfe0","chunk-5ddea5ea":"31d6cfe0","chunk-5fd9ef88":"31d6cfe0","chunk-609a6aeb":"2ddf9451","chunk-609e28f6":"4e3f5168","chunk-636f4260":"6a778d04","chunk-646bac48":"31d6cfe0","chunk-66173c80":"31d6cfe0","chunk-6700755d":"826d82f5","chunk-67147130":"31d6cfe0","chunk-67811b1b":"31d6cfe0","chunk-67db813b":"31d6cfe0","chunk-6993bb39":"31d6cfe0","chunk-6ac44d3d":"31d6cfe0","chunk-6b3b5ac7":"31d6cfe0","chunk-6cd8d239":"8f543a3f","chunk-4dc0318a":"4aa6b438","chunk-c154174a":"e3a93821","chunk-6d7092e8":"31d6cfe0","chunk-6d90af06":"31d6cfe0","chunk-6e6dcf96":"31d6cfe0","chunk-6f384fdc":"31d6cfe0","chunk-6f5955ca":"31d6cfe0","chunk-00357acc":"31d6cfe0","chunk-17d2ea76":"31d6cfe0","chunk-31e3aaf3":"31d6cfe0","chunk-3635a07f":"31d6cfe0","chunk-4b330e93":"31d6cfe0","chunk-4e2546e6":"31d6cfe0","chunk-540eb546":"31d6cfe0","chunk-59d91b22":"31d6cfe0","chunk-844aa964":"31d6cfe0","chunk-8f099ab8":"31d6cfe0","chunk-9fe4383e":"31d6cfe0","chunk-b92141c0":"31d6cfe0","chunk-dd2b1d46":"31d6cfe0","chunk-6f60227b":"31d6cfe0","chunk-70e35ebc":"31d6cfe0","chunk-711ff2f0":"31d6cfe0","chunk-71bd526a":"31d6cfe0","chunk-72294d4c":"31d6cfe0","chunk-73e9d5f2":"31d6cfe0","chunk-744c292d":"3aac4123","chunk-7459c046":"3426b597","chunk-75203fab":"31d6cfe0","chunk-75b8b6cb":"31d6cfe0","chunk-77f6f964":"31d6cfe0","chunk-78ab511f":"31d6cfe0","chunk-7cdb600e":"31d6cfe0","chunk-7e16cd9d":"31d6cfe0","chunk-7ed8b0ce":"8a41c503","chunk-7f66c91b":"66183a72","chunk-7f706172":"11711f41","chunk-7fb62e64":"31d6cfe0","chunk-8039543e":"a60f24a6","chunk-8c0aeddc":"31d6cfe0","chunk-2b02de32":"31d6cfe0","chunk-7f881edd":"31d6cfe0","chunk-9827d096":"31d6cfe0","chunk-982b6af2":"31d6cfe0","chunk-99bcc778":"31d6cfe0","chunk-9ac5abb0":"31d6cfe0","chunk-9eba3760":"31d6cfe0","chunk-a39ff88a":"f336c531","chunk-a8544154":"31d6cfe0","chunk-ac7c3ac8":"31d6cfe0","chunk-adc2bb66":"31d6cfe0","chunk-b0a53dac":"31d6cfe0","chunk-b81bcb8a":"31d6cfe0","chunk-ba7d386c":"31d6cfe0","chunk-bb9055bc":"31d6cfe0","chunk-bc926f2a":"31d6cfe0","chunk-c5f01380":"31d6cfe0","chunk-c6b29aa4":"31d6cfe0","chunk-cf78b932":"31d6cfe0","chunk-d2175d8a":"9a85fade","chunk-e1a6d904":"31d6cfe0","chunk-ed77b080":"31d6cfe0","chunk-faf9c3f6":"36527024","fail":"31d6cfe0","lang-en-US":"31d6cfe0","lang-en-US-setting":"31d6cfe0","lang-vi":"31d6cfe0","lang-vi-setting":"31d6cfe0","user":"d63f9ae0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
